// components/FeedbackModal.js
import React from "react";
import { FiX } from 'react-icons/fi';
import styles from './FeedbackModal.module.css';

export default function FeedbackModal({ isOpen, onClose, onSubmit, feedbackText, onFeedbackTextChange, theme }) {
  if (!isOpen) return null;
  const isSubmitDisabled = !feedbackText.trim();
  return (
    <div className={styles.feedbackModalOverlay} onClick={onClose}>
      <div className={styles.feedbackModalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.feedbackModalHeader}>
          <h3>Quer compartilhar o que achou?</h3>
          <button onClick={onClose} className={styles.feedbackModalCloseBtn}><FiX size={24} /></button>
        </div>
        <div className={styles.feedbackModalBody}>
          <textarea
            value={feedbackText}
            onChange={onFeedbackTextChange}
            placeholder="Isso te ajudou como você esperava?"
            className={styles.feedbackModalTextarea}
          />
          <button
            onClick={onSubmit}
            className={styles.feedbackModalSubmitBtn}
            style={{ 
              backgroundColor: theme.accent, 
              color: '#fff',
              opacity: isSubmitDisabled ? 0.6 : 1,
              cursor: isSubmitDisabled ? 'not-allowed' : 'pointer'
            }}
            disabled={isSubmitDisabled}
          >
            Compartilhar Opinião
          </button>
        </div>
      </div>
    </div>
  );
}